namespace Matrix.Rebalancer {
    export class TradeMacroStepColumns {
        static columnsKey = 'Rebalancer.TradeMacroStep';
    }
}
